export const FunPage = () => {
  return <h1>FunPage</h1>;
};
